import type { ViewOptionsGroup } from '@/engine/app/interfaces';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';
import type { VisibilityLinkedVMController } from './VisibilityLinkedVMController';

export class SetGroupVisibilityCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private readonly _visibilityLinkedVmController: VisibilityLinkedVMController;

  private readonly _viewOptionsGroup: ViewOptionsGroup;

  private readonly _makeVisible: boolean;

  private readonly _originalStates: Map<string, boolean> = new Map();

  public constructor(
    viewsService: ViewsService,
    visibilityLinkedVmController: VisibilityLinkedVMController,
    viewOptionsGroup: ViewOptionsGroup,
    makeVisible: boolean
  ) {
    this._viewsService = viewsService;
    this._visibilityLinkedVmController = visibilityLinkedVmController;
    this._viewOptionsGroup = viewOptionsGroup;
    this._makeVisible = makeVisible;
  }

  public execute(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const viewOption of this._viewOptionsGroup.children) {
      for (const object of objects) {
        if (viewOption.descriptors.includes(object.descriptor)) {
          this._originalStates.set(object.descriptor, object.isVisible);
          object.setVisibility(this._makeVisible);
          this._visibilityLinkedVmController.setLinkedObjectVisibility(
            object.descriptor,
            this._viewsService.currentView,
            this._makeVisible
          );
        }
      }
    }
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._originalStates.has(object.descriptor)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const visibility = this._originalStates.get(object.descriptor)!;
        object.setVisibility(visibility);
        this._visibilityLinkedVmController.setLinkedObjectVisibility(
          object.descriptor,
          this._viewsService.currentView,
          visibility
        );
      }
    }
    return Promise.resolve(true);
  }
}
